import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "@/pages/landing/Landing";
import NotFound from "@/pages/authentication/NotFound";
import Login from "@/pages/authentication/Login";
import SignUp from "@/pages/authentication/SignUp";
import ForgotPassword from "@/pages/authentication/ForgotPassword";
import ResetPassword from "@/pages/authentication/ResetPassword";
import Dashboard from "@/pages/dashboard/Dashboard";
import { get } from "lodash";
import request from "@/modules/request";

import DefaultLayout from "@/components/layouts/DefaultLayout";

// Associate pages
import AssociateDashboard from "@/pages/associate/dashboard/Dashboard";
import Customers from "@/pages/associate/customers/Customers";
import AssociateOrders from "@/pages/associate/orders/Orders";
import Distributors from "@/pages/associate/distributors/Distributors";
import AssociateTemplates from "@/pages/associate/templates/Templates";
import Users from "@/pages/associate/users/Users";
import AddCustomer from "@/pages/associate/customers/AddCustomer";
import AddDistributor from "@/pages/associate/distributors/AddDistributor";
import Distributor from "@/pages/associate/distributors/Distributor";
import Customer from "@/pages/associate/customers/Customer";
import AssociateCreateTemplate from "@/pages/associate/templates/CreateTemplate";
import AssociateCreateOrder from "@/pages/associate/orders/CreateOrder";
import AssociateOrder from "@/pages/associate/orders/Order";
import Settings from "@/pages/admin/Settings";
import EmailSettings from "@/pages/admin/EmailSettings";
import AssociateInvite from "@/pages/authentication/AssociateInvite";
import AssociateTemplate from "@/pages/associate/templates/Template";
import ProductManagement from "@/pages/admin/ProductManagement";
import AddProduct from "@/pages/admin/AddProduct";
import Upload from "@/pages/admin/Upload";
import ProductCategories from "@/pages/admin/ProductCategories";
import Associates from "@/pages/admin/Associates";
import Roles from "@/pages/admin/Roles";
import Associate from "@/pages/admin/Associate";

//User pages
import UserInvite from "@/pages/authentication/UserInvite";
import UserOrder from "@/pages/user/orders/Order";
import UserCreateOrder from "@/pages/user/orders/CreateOrder";
import UserOrders from "@/pages/user/orders/Orders";
import UserTemplate from "@/pages/user/templates/Template";
import UserTemplates from "@/pages/user/templates/Templates";
import UserCreateTemplate from "@/pages/user/templates/CreateTemplate";

Vue.use(VueRouter);

// TODO - better organize associate vs user routes
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/signup",
      name: "Signup",
      component: SignUp,
    },
    {
      path: "/login",
      name: "UserLogin",
      component: Login,
    },
    {
      path: "/forgotpassword",
      name: "UserForgotPassword",
      component: ForgotPassword,
      props: {
        associate: false,
      },
    },
    {
      path: "/resetpassword/",
      name: "UserResetPassword",
      component: ResetPassword,
      props: {
        associate: false,
      },
    },
    {
      path: "/admin/login",
      name: "AssociateLogin",
      component: Login,
    },
    {
      path: "/admin/invite",
      name: "AssociateInvite",
      component: AssociateInvite,
    },
    {
      path: "/invite/",
      name: "InviteUser",
      component: UserInvite,
    },
    {
      path: "/admin/forgotpassword",
      name: "AssociateForgotPassword",
      component: ForgotPassword,
      props: {
        associate: true,
      },
    },
    {
      path: "/admin/resetpassword/",
      component: ResetPassword,
      name: "AssociateResetPassword",
      props: {
        associate: true,
      },
    },
    {
      path: "/notfound",
      name: "NotFound",
      component: NotFound,
    },
    {
      path: "/",
      component: DefaultLayout,
      children: [
        {
          path: "/",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            pageTitle: "",
            requiresAuth: true,
          },
        },
        {
          path: "/admin/",
          name: "AssociateDashboard",
          component: AssociateDashboard,
          meta: {
            requiresAuth: true,
            pageTitle: "",
          },
        },
        {
          path: "/admin/customers",
          name: "Customers",
          component: Customers,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Customers",
          },
        },
        {
          path: "/admin/orders",
          name: "AssociateOrders",
          component: AssociateOrders,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Orders",
          },
        },
        {
          path: "/admin/distributors",
          name: "Distributors",
          component: Distributors,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Distributors",
          },
        },
        {
          path: "/admin/templates",
          name: "AssociateTemplates",
          component: AssociateTemplates,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Templates",
          },
        },
        {
          path: "/admin/createtemplate",
          name: "AssociateCreateTemplate",
          component: AssociateCreateTemplate,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "New Order Template",
          },
        },
        {
          path: "/admin/template/:id",
          name: "AssociateTemplate",
          component: AssociateTemplate,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Template",
          },
        },
        {
          path: "/admin/users",
          name: "Users",
          component: Users,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Users",
          },
        },
        {
          path: "/admin/customers/add",
          name: "AddCustomer",
          component: AddCustomer,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Add Customer",
          },
        },
        {
          path: "/admin/customer/:id",
          name: "Customer",
          component: Customer,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Customer Details",
          },
        },
        {
          path: "/admin/distributors/add",
          name: "AddDistributor",
          component: AddDistributor,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Add Distributor",
          },
        },
        {
          path: "/admin/distributor/:id",
          name: "Distributor",
          component: Distributor,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Distributor Details",
          },
        },
        {
          path: "/admin/createorder",
          name: "AssociateCreateOrder",
          component: AssociateCreateOrder,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "New Order",
          },
        },
        {
          path: "/admin/order/:id",
          name: "AssociateOrder",
          component: AssociateOrder,
          meta: {
            requiresAuth: true,
            associate: true,
            pageTitle: "Order Details",
          },
        },
        {
          path: "/orders",
          name: "UserOrders",
          component: UserOrders,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "Orders",
          },
        },
        {
          path: "/order/:id",
          name: "UserOrder",
          component: UserOrder,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "Order Details",
          },
        },
        {
          path: "/createorder",
          name: "UserCreateOrder",
          component: UserCreateOrder,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "New Order",
          },
        },
        {
          path: "/template/:id",
          name: "UserTemplate",
          component: UserTemplate,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "Template",
          },
        },
        {
          path: "/templates",
          name: "UserTemplates",
          component: UserTemplates,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "Order Templates",
          },
        },
        {
          path: "/createtemplate",
          name: "UserCreateTemplate",
          component: UserCreateTemplate,
          meta: {
            requiresAuth: true,
            associate: false,
            pageTitle: "New Order Template",
          },
        },
        {
          path: "/settings/",
          name: "Settings",
          icon: "settings",
          component: Settings,
          children: [
            {
              path: "/admin/settings/emails",
              name: "EmailSettings",
              component: EmailSettings,
              icon: "email",
              meta: {
                pageTitle: "Email Settings",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/product-management",
              name: "ProductManagement",
              component: ProductManagement,
              meta: {
                pageTitle: "Product Management",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/addproduct",
              name: "AddProduct",
              component: AddProduct,
              meta: {
                pageTitle: "New Product",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/productcategories",
              name: "ProductCategories",
              component: ProductCategories,
              meta: {
                pageTitle: "Manage Product Categories",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/associates",
              name: "Associates",
              component: Associates,
              meta: {
                pageTitle: "Manage Associates",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/associate/:id",
              name: "Associate",
              component: Associate,
              meta: {
                pageTitle: "Associate",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/roles",
              name: "Roles",
              component: Roles,
              meta: {
                pageTitle: "Manage Roles & Permissions",
                requiresAuth: true,
                associate: true,
              },
            },
            {
              path: "/admin/upload",
              name: "Upload",
              component: Upload,
              meta: {
                pageTitle: "Upload",
                requiresAuth: true,
                associate: true,
              },
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const { requiresAuth } = get(to, "meta");
  const isAssociateRoute = to.path.includes("admin") ? true : false; // TODO - update this to use meta
  const loginRoute = isAssociateRoute ? "AssociateLogin" : "UserLogin";
  if (requiresAuth) {
    const results = await request
      .callInternal({
        method: "post",
        route: "/api/authcheck",
      })
      .catch((error) => {
        console.error(error);
        return next({
          name: loginRoute,
        });
      });
    if (results) {
      const userType = results.data.userType;
      if (isAssociateRoute && userType !== "associate") {
        localStorage.removeItem("token");
        return next({
          name: loginRoute,
        });
      }

      if (!isAssociateRoute && userType === "associate") {
        localStorage.removeItem("token");
        return next({
          name: loginRoute,
        });
      }

      localStorage.setItem("activeUser", JSON.stringify(results.data));
      next();
    } else {
      localStorage.removeItem("token");
      return next({
        name: loginRoute,
      });
    }
  }
  next();
});

export default router;
